import { ReduxState } from 'ra-core';
import {
    SecurityProfile,
    GetAirlineState
} from "../components/agent/types"
import { LocaleState, ThemeState, FontState, DirectionState } from '../components/configurations/types';
import * as constants from './index';
import { AppInfoInitialState, IamListInitialState } from '../components/authentication/types';
import { CityListState, FlightTypeListState, ConfirmMonitoringListState } from '../components/FlightRequest/types';
import { FlightRequestsListState, HiddenColumnsState, ColumnsOrderState, SelectedRequestsState, SelectedFiltersState } from '../components/FlightRequestList/types';
import { FlightListState } from '../components/Calendar/types';
import { FlightRequestReportsListState } from "../components/FlightRequestReport/types"
import { RplsListState } from "../components/Rpl/types"
import { FlightRequestInitialState, CreateFlightRequestInitialState } from '../components/FlightRequest/types';
import { FlightsByFlightNumberState, CancelFlightRequestState } from '../components/FlightCancellation/types';
import { ReEstablishRequestState } from '../components/FlightRestablish/types';
import { TimeChangeRequestState } from '../components/FlightTimeChange/types';
import { FlightRequestHistoryInfoInitialState } from '../components/History/types';
import { Rule, Airline } from '../components/Rules/types';
import {
    ConfirmOfferFlightRequestInitialState,
    AirlineFinalRejectFlightRequestInitialState,
    AirlineRequestAfterRejectionInitialState,
} from '../components/FlightRequestOffer/types';
import {
    FlightRequestsState,
    ApproveFlightRequestInitialState,
    SaveFlightRequestInitialState,
    RejectFlightRequestInitialState,
    OfferFlightRequestInitialState,
    SubmitOfferFlightRequestInitialState
} from '../components/FlightRequestDetails/types';
import { UsersState, UsersPaginationState } from '../components/security/types';

export type FormState = 'NEW' | 'INFO' | 'EDIT';
export const FromMode: { [key in FormState]: FormState } = {
    NEW: 'NEW',
    INFO: 'INFO',
    EDIT: 'EDIT',
};

export interface IBaseAction {
    meta?: { fetch: string; resource: string };
}

export class PaginationQuery implements IPaginationQuery {
    rowCount = null;
    pageSize = constants.configuration.DEFAULT_PAGE_SIZE;
    pageIndex = 0;
    pageNumber = null;
    sortOrder = null;
    sortPropertyName = null;
    withCount = true;

    protected constructor() { }
}

export interface IPaginationQuery {
    rowCount: number | null;
    pageSize: number;
    pageIndex: number;
    pageNumber: number | null;
    sortOrder: string | null;
    sortPropertyName: string | null;
    withCount: boolean;
}

export interface AppState extends ReduxState {
    locale: LocaleState;
    theme: ThemeState;
    font: FontState;
    direction: DirectionState;
    largeWindow: boolean;
    securityProfile: SecurityProfile,
    appInfo: AppInfoInitialState;
    panelFilter: string;
    iamLists: IamListInitialState;
    cityList: CityListState;
    flightTypesList: FlightTypeListState;
    confirmMonitoring: ConfirmMonitoringListState;
    flightRequestList: FlightRequestsListState;
    flightList: FlightListState;
    createFlightRequestResult: CreateFlightRequestInitialState;
    reviewFlightRequestResult: FlightRequestInitialState;
    approveFlightRequestResult: ApproveFlightRequestInitialState;
    getFlightRequest: FlightRequestsState;
    saveFlightRequestResult: SaveFlightRequestInitialState;
    rejectFlightRequestResult: RejectFlightRequestInitialState;
    offerFlightRequestResult: OfferFlightRequestInitialState;
    submitOfferFlightRequestResult: SubmitOfferFlightRequestInitialState;
    confirmOfferResult: ConfirmOfferFlightRequestInitialState;
    finalRejectionOfFlightRequest: AirlineFinalRejectFlightRequestInitialState;
    requestAfterRejection: AirlineRequestAfterRejectionInitialState;
    getFlightRequestHistoriesResult: FlightRequestHistoryInfoInitialState;
    hiddenColumns: HiddenColumnsState;
    columnsOrder: ColumnsOrderState;
    selectedRequests: SelectedRequestsState;
    rules: Rule;
    currentAirline: GetAirlineState;
    flightsByFlightNumber: FlightsByFlightNumberState;
    cancelFlightRequest: CancelFlightRequestState;
    reEstablishRequest: ReEstablishRequestState;
    reEstablishFlights: any;
    reEstablishFlightsAfterRejection: any;
    timeChangeRequest: TimeChangeRequestState;
    timeChangeFlights: any;
    timeChangeFlightsAfterRejection: any;
    flightInfo: any;
    previewFlightRequestReport: any;
    createFlightRequestReport: any;
    flightRequestReports: FlightRequestReportsListState;
    selectedFilters: SelectedFiltersState;
    expandedAccordion: number;
    airlinesList: Array<Airline>;
    rplsList: RplsListState;
    users: UsersPaginationState;
    usersOptions: UsersState;
    calendarView: string;
    statusTranslation: any;
}
